var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "178",
        height: "136",
        viewBox: "0 0 178 136",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("path", {
        attrs: { d: "M177.149 0H0V136H177.149V0Z", fill: "#E21E21" },
      }),
      _c("path", {
        attrs: {
          d: "M147 0H121.643C115.994 3.58552 110.679 8.36435 105.988 14.4857C83.3377 44.0409 83.3375 91.9588 105.988 121.514C110.679 127.636 115.994 132.414 121.643 136H147V0Z",
          fill: "#F47277",
        },
      }),
      _c("path", {
        attrs: {
          d: "M177 0H148.583C142.252 3.58552 136.296 8.36435 131.038 14.4857C105.654 44.0409 105.654 91.9588 131.038 121.514C136.296 127.636 142.252 132.414 148.583 136H177V0Z",
          fill: "#EC4347",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }